import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Testimonials from '../components/Testimonials';
import Services from '../components/Services';
import Footer from '../components/Footer';
import VSL from '../components/VSL';

const Home = () => {
  return (
    <div className="min-h-screen bg-black-pure text-white overflow-x-hidden">
      <Header />
      <Hero />
      {/* VSL è già integrato nell'Hero */}
      <Testimonials />
      <Services />
      <Footer />
    </div>
  );
};

export default Home;